const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()

    if (!this.els.thumbnail?.exists) return
    this.handleThumbnail = this.handleThumbnail.bind(this)

    this.els.thumbnail.elements.forEach((thumbnailEl) => {
      this.listeners.add(thumbnailEl, 'click', this.handleThumbnail)
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els.thumbnail.elements.forEach((thumbnailEl) => {
            thumbnailEl.setAttribute(
              'aria-current',
              thumbnailEl.dataset.index === activeIndex.toString(),
            )
          })
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  handleThumbnail (event) {
    if (!event.target.closest(this.els?.thumbnail?.selector)) return

    const clickedTrigger = event.target.closest(this.els?.thumbnail?.selector)

    if (!clickedTrigger) return
    const clickedIndex = parseInt(clickedTrigger.dataset.index)

    this.carousel.moveToIdx(clickedIndex)
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
